









































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { InfoState } from '@/core/core.store';
import {
  SwModal,
  SwModalBody,
  SwModalFooter,
} from '@libs-uuif/shared/sw-modal';
import UserSelector from './user-selector.vue';

const cssPrefix = 'psa-hub';

@Component({
  components: {
    ...UUIFComponents,
    SwModal,
    SwModalBody,
    SwModalFooter,
    UserSelector,
  },
})

export default class PSAHubMainTab extends SwExtendedVue {
  cssPrefix = cssPrefix;
  showManageModal: boolean = false;
  availableUsers: any = [];
  selectedAvailableUsers: any = [];
  assignedUsers: any = [];
  selectedAssignedUsers: any = [];
  redirectUrl: string = '';
  redirectMessage: string = '';

  get getDisplayText() {
    return this.$store.getters['PsaHubStoreModule/getDisplayText'] || '';
  }

  get isShowConfigure() {
    return this.$store.getters['PsaHubStoreModule/isShowConfigure'] || false;
  }

  get isOrgEnabled() {
    return this.$store.getters['PsaHubStoreModule/isOrgEnabled'] || false;
  }

  get isShowManage() {
    return this.$store.getters['PsaHubStoreModule/isShowManage'] || false;
  }

  get isShowLaunch() {
    return this.$store.getters['PsaHubStoreModule/isShowLaunch'] || false;
  }

  closeDialog() {
    this.showManageModal = false;
  }

  redirectToNeedHelp() {
    window.open('https://www.sonicwall.com/support/knowledge-base/psa-integrations-hub-by-sonicwall/250227091504950', '_blank');
  }

  configureGradient() {
    this.$store.dispatch('PsaHubStoreModule/manageGradient', { mode: 'SET' })
      .then((resp: any) => {
        if (resp && (resp.msgCode === 'MSWAPP:SUCCESS') && (resp.operationStatus === 'OK')) {
          const message: InfoState = { infoType: 'success', infoMsg: 'Success' };
          this.$store.commit('enqueueMessage', message);
        }
      })
      .catch(() => {
        const message: InfoState = { infoType: 'failed', infoMsg: 'Failed' };
        this.$store.commit('enqueueMessage', message);
      }).finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  manageGradient() {
    this.$store.dispatch('PsaHubStoreModule/manageGradient', { mode: 'GETMANAGE' })
      .then((resp: any) => {
        if (resp && (resp.msgCode === 'MSWAPP:SUCCESS') && (resp.operationStatus === 'OK')) {
          this.availableUsers = this.$store.getters['PsaHubStoreModule/getAvailableUsers'] || [];
          this.assignedUsers = this.$store.getters['PsaHubStoreModule/getAssignedUsers'] || [];
          this.showManageModal = true;
        }
      })
      .catch(() => {
        const message: InfoState = { infoType: 'failed', infoMsg: 'Failed' };
        this.$store.commit('enqueueMessage', message);
      }).finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  onAvailableUserChange(value: any) {
    this.selectedAvailableUsers = value;
  }

  onAssignedUserChange(value: any) {
    this.selectedAssignedUsers = value;
  }

  onAdd() {
    this.assignedUsers.push(...this.selectedAvailableUsers);
    this.availableUsers = this.availableUsers.filter((user: any) => !this.selectedAvailableUsers.includes(user));
    this.selectedAvailableUsers = [];
  }

  onRemove() {
    this.availableUsers.push(...this.selectedAssignedUsers);
    this.assignedUsers = this.assignedUsers.filter((user: any) => !this.selectedAssignedUsers.includes(user));
    this.selectedAssignedUsers = [];
  }

  onProceed() {
    const tempList = this.assignedUsers.map((el: any) => {
      return el.partyId;
    });
    const userList = tempList.join(',');
    this.$store.dispatch('PsaHubStoreModule/manageGradient', { userList, mode : 'SETMANAGE' })
      .then((resp: any) => {
        if (resp && (resp.msgCode === 'MSWAPP:SUCCESS') && (resp.operationStatus === 'OK')) {
          this.closeDialog();
          const message: InfoState = { infoType: 'success', infoMsg: 'Success' };
          this.$store.commit('enqueueMessage', message);
        }
      })
      .catch(() => {
        const message: InfoState = { infoType: 'failed', infoMsg: 'Failed' };
        this.$store.commit('enqueueMessage', message);
      }).finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  onLaunchClick() {
    this.$store.dispatch('PsaHubStoreModule/manageGradient', { mode : 'LAUNCH' })
      .then((resp: any) => {
        if (resp && (resp.msgCode === 'MSWAPP:SUCCESS') && (resp.operationStatus === 'OK')) {
          this.redirectMessage = resp.content.displayText;
          this.redirectUrl = resp.content.orgId;
          window.open(this.redirectUrl, '_blank');
          this.redirectMessage = '';
        }
      })
      .catch(() => {
        const message: InfoState = { infoType: 'failed', infoMsg: 'Failed' };
        this.$store.commit('enqueueMessage', message);
      }).finally(() => {
        this.$store.commit('stopLoading');
      });
  }
}
